import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWallLeft"><Path d="M11.25 7.25L6.5 12L11.25 16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 12H7.25" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWallLeft;
